import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

// main components
import TabBar from './components/TabBar'
import StackContent from './components/StackContent'
import HiddenEntityStack from './components/HiddenEntityStack'

import GroupStack from '../GroupStack'

import { shouldUpdateEntityStack } from './helpers'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class EntityStack extends Component {
    static propTypes = {
        activeGroupId: PropTypes.string,
        activeTab: PropTypes.string.isRequired,
        entityStackRemoveNotification: PropTypes.func.isRequired,
        hasRibbon: PropTypes.bool.isRequired,
        changeEntityStackTab: PropTypes.func.isRequired,
        notifications: PropTypes.object,
        ribbonOpen: PropTypes.bool.isRequired,
        swChangeEntityStackTab: PropTypes.func.isRequired,
        toggleEntityStack: PropTypes.func.isRequired,
        visibleEntityStack: PropTypes.bool.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        return shouldUpdateEntityStack(this.props, nextProps)
    }

    render() {
        const {
            activeTab,
            changeEntityStackTab,
            hasRibbon,
            ribbonOpen,
            toggleEntityStack,
            visibleEntityStack,
            activeGroupId,
            swChangeEntityStackTab,
            entityStackRemoveNotification,
            notifications,
        } = this.props

        return (
            <div
                className={cx(
                    'entity-stack',
                    !visibleEntityStack && 'hide',
                    (!hasRibbon || !ribbonOpen) && 'ribbon-hide'
                )}
            >
                <div className={cx('entity-stack-wrap')}>
                    <TabBar
                        activeTab={activeTab}
                        activeGroupId={activeGroupId}
                        changeEntityStackTab={changeEntityStackTab}
                        toggleEntityStack={toggleEntityStack}
                        swChangeEntityStackTab={swChangeEntityStackTab}
                        notifications={notifications}
                        entityStackRemoveNotification={entityStackRemoveNotification}
                    />
                    <StackContent activeTab={activeTab} />
                </div>
                <HiddenEntityStack toggleEntityStack={toggleEntityStack} hide={visibleEntityStack} />
                <GroupStack />
            </div>
        )
    }
}
